var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Hype/AbonelikYok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Profilim06---\\xD6demelerim-Data-Yok",
    transform: "translate(-761.000000, -365.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(134.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(360.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(268.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,-0.5 C31.7917046,-0.5 35.4809488,0.241065355 38.9091119,1.66259502 C39.1641937,1.7683678 39.2852326,2.06089825 39.1794598,2.31598006 C39.073687,2.57106186 38.7811566,2.69210074 38.5260748,2.58632796 C35.2188102,1.21493037 31.6596738,0.5 28,0.5 C12.8121694,0.5 0.5,12.8121694 0.5,28 C0.5,43.1878306 12.8121694,55.5 28,55.5 C43.1878306,55.5 55.5,43.1878306 55.5,28 C55.5,24.3403262 54.7850696,20.7811898 53.413672,17.4739252 C52.030342,14.1378844 49.9981419,11.1072689 47.4454365,8.55456352 C47.2501743,8.35930137 47.2501743,8.04271888 47.4454365,7.84745674 C47.6406986,7.65219459 47.9572811,7.65219459 48.1525433,7.84745674 C50.7976701,10.4925836 52.9036329,13.6332012 54.337405,17.0908881 C55.7589346,20.5190512 56.5,24.2082954 56.5,28 C56.5,43.7401154 43.7401154,56.5 28,56.5 C12.2598846,56.5 -0.5,43.7401154 -0.5,28 C-0.5,12.2598846 12.2598846,-0.5 28,-0.5 Z",
    id: "Path",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9106445,12.3037196 C30.9267578,12.3037196 33.0083008,14.6054342 33.0649414,17.0896018 L33.0649414,17.0896018 L35.6137695,17.0896018 C38.105957,17.0896018 39.4086914,18.3808075 39.4086914,20.8228706 L39.4086914,20.8228706 L39.4086914,34.7735066 C39.4086914,37.2296045 38.1201172,38.5208103 35.7978516,38.5208103 L35.7978516,38.5208103 L20.1933594,38.5208103 C17.7011719,38.5208103 16.4125977,37.2436394 16.4125977,34.7735066 L16.4125977,34.7735066 L16.4125977,20.8228706 C16.4125977,18.3527378 17.7011719,17.0896018 20.1933594,17.0896018 L20.1933594,17.0896018 L22.7563477,17.0896018 C22.7988281,14.5913993 24.8803711,12.3037196 27.9106445,12.3037196 Z M27.9106445,13.6089602 C25.6166992,13.6089602 24.1582031,15.2931416 24.1157227,17.0896018 L24.1157227,17.0896018 L31.6914062,17.0896018 C31.6489258,15.2931416 30.1904297,13.6089602 27.9106445,13.6089602 Z",
    id: "Combined-Shape",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7695312,37.1594303 L20.2358398,37.1594303 C18.6357422,37.1594303 17.7719727,36.3313744 17.7719727,34.7033324 L17.7719727,20.8930448 C17.7719727,19.2790376 18.6357422,18.4369469 20.2358398,18.4369469 L35.5712891,18.4369469 C37.1430664,18.4369469 38.0351562,19.2790376 38.0351562,20.8930448 L38.0351562,34.7033324 C38.0351562,36.3313744 37.1430664,37.1594303 35.7695312,37.1594303 Z",
    id: "Path",
    fill: "#5ac0de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sad",
    transform: "translate(30.237793, 30.022470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21435547,14.2937638 C11.1621094,14.2937638 14.4213867,11.0633296 14.4213867,7.15051162 C14.4213867,3.23043418 11.1547852,0 7.20703125,0 C3.25927734,0 0,3.23043418 0,7.15051162 C0,11.0633296 3.25927734,14.2937638 7.21435547,14.2937638 Z",
    id: "Path",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21435547,12.7620299 C4.07226562,12.7620299 1.55273437,10.257536 1.55273437,7.15051162 C1.55273437,4.03622788 4.06494141,1.53173396 7.20703125,1.53173396 C10.3491211,1.53173396 12.8686523,4.03622788 12.8759924,7.15051162 C12.8833008,10.257536 10.3491211,12.7620299 7.21435547,12.7620299 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21435547,10.293833 C8.75244141,10.293833 9.77050781,9.21218197 9.77050781,8.7548396 C9.77050781,8.66046737 9.70458984,8.61691095 9.63134766,8.67498617 C9.15527344,9.05973451 8.3203125,9.43722345 7.21435547,9.43722345 C6.10839844,9.43722345 5.25146484,9.04521571 4.79003906,8.67498617 C4.71679688,8.62417035 4.65087891,8.66046737 4.65087891,8.7548396 C4.65087891,9.21218197 5.66894531,10.293833 7.21435547,10.293833 Z",
    id: "Path",
    fill: "#303030",
    transform: "translate(7.210693, 9.471298) scale(1, -1) translate(-7.210693, -9.471298) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2734375,6.52620299 C5.66894531,6.52620299 6.00585938,6.18501106 6.00585938,5.69863108 C6.00585938,5.21225111 5.66894531,4.86379978 5.2734375,4.86379978 C4.87792969,4.86379978 4.55566406,5.21225111 4.55566406,5.69863108 C4.55566406,6.18501106 4.87792969,6.52620299 5.2734375,6.52620299 Z",
    id: "Path",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16259766,6.52620299 C9.55810547,6.52620299 9.89501953,6.18501106 9.89501953,5.69863108 C9.89501953,5.21225111 9.55810547,4.86379978 9.16259766,4.86379978 C8.77441406,4.86379978 8.44482422,5.21225111 8.44482422,5.69863108 C8.44482422,6.18501106 8.77441406,6.52620299 9.16259766,6.52620299 Z",
    id: "Path",
    fill: "#303030"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.0e0cfd19b6db085bc699345ca20dc3b4.svg";
export { ForwardRef as ReactComponent };